export default __webpack_public_path__ + "static/media/cords.161d2661.svg";